import { render, staticRenderFns } from "./FullListHistory.vue?vue&type=template&id=ba33cc62&lang=pug&"
import script from "./FullListHistory.vue?vue&type=script&lang=ts&"
export * from "./FullListHistory.vue?vue&type=script&lang=ts&"
import style0 from "./FullListHistory.vue?vue&type=style&index=0&id=ba33cc62&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports